import { useCallback, useReducer } from 'react';
import taskDeleteReducer, { initialState } from 'collaboration-sidebar/reducers/taskDelete';
import { MSG_TYPE_CONFIRM_DELETE_TASK, MSG_TYPE_DELETE_TASK, MSG_TYPE_DELETE_TASK_FAILURE, MSG_TYPE_DELETE_TASK_SUCCESS, MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL, MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL } from 'collaboration-sidebar/constants/IFrameMessageTypes';
export default function useTaskDeleteModal({
  sendMessageRef,
  isSendMessageReady
}) {
  const [state, dispatch] = useReducer(taskDeleteReducer, initialState);
  const {
    show,
    taskId
  } = state;
  const handleMessage = useCallback(({
    payload
  }) => {
    switch (payload.type) {
      case MSG_TYPE_DELETE_TASK_SUCCESS:
      case MSG_TYPE_DELETE_TASK_FAILURE:
      case MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL:
        dispatch(payload);
        break;
      default:
        dispatch(payload);
        break;
    }
  }, []);
  const onClose = useCallback(() => {
    if (show) {
      dispatch({
        type: MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL
      });
    }
  }, [show]);
  const onDelete = useCallback(() => {
    if (show && isSendMessageReady && sendMessageRef.current && taskId) {
      sendMessageRef.current(MSG_TYPE_DELETE_TASK, {
        taskId
      });
      dispatch({
        type: MSG_TYPE_CONFIRM_DELETE_TASK
      });
    } else {
      dispatch({
        type: MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL
      });
    }
  }, [sendMessageRef, show, taskId, isSendMessageReady]);
  return Object.assign({}, state, {
    handleMessage,
    onClose,
    onDelete
  });
}